import { StandardLayout } from "common/layouts/StandardLayout";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { ExperiencesBillingContainer } from "./ExperiencesBilling";
import { OrganizationChallenges } from "./OrganizationChallenges";
import { OrganizationCollections } from "./OrganizationCollections";
import { OrganizationsSearch } from "./OrganizationsSearch";

const AppWrapper = ({ children }) => <StandardLayout greyBg>{children}</StandardLayout>;

export const routes = ({ match: { path } }) => (
  <Switch>
    <Route
      path={`${path}/search`}
      render={() => (
        <AppWrapper>
          <OrganizationsSearch />
        </AppWrapper>
      )}
    />
    <Route
      path={`${path}/:organizationId/experiences_billing`}
      render={() => (
        <AppWrapper>
          <ExperiencesBillingContainer />
        </AppWrapper>
      )}
    />
    <Route path={`${path}/:clubIdParam/challenges`} component={OrganizationChallenges} />
    <Route path={`${path}/:clubIdParam/collections`} component={OrganizationCollections} />
  </Switch>
);
